import { useSaveAsNewCollectionModalStore } from "../../../js/stores/save-as-new-collection-modal-store";
import { Dialog, DialogContent } from "../shared/modal";
import { SaveAsNewCollectionContent } from "./save-as-new-collection-content";

function SaveAsNewCollectionDialog({ isModalOpen, updateIsModalOpen }) {
  return (
    <Dialog
      open={isModalOpen}
      onClose={() => updateIsModalOpen(false)}
      onOpenChange={updateIsModalOpen}
    >
      <DialogContent>
        <SaveAsNewCollectionContent closeClickHandler={() => updateIsModalOpen(false)} />
      </DialogContent>
    </Dialog>
  );
}

export function SaveAsNewCollectionModal() {
  const isModalOpen = useSaveAsNewCollectionModalStore((state) => state.isModalOpen);
  const updateIsModalOpen = useSaveAsNewCollectionModalStore(
    (state) => state.updateIsModalOpen
  );

  return (
    <>
      {isModalOpen && (
        <SaveAsNewCollectionDialog
          key={crypto?.randomUUID()}
          isModalOpen={isModalOpen}
          updateIsModalOpen={updateIsModalOpen}
        />
      )}
    </>
  );
}
